import { Observable } from 'rxjs';
import {
  ApiService,
  GET_ADMIN_GAMES_FOR_POST_PATH,
  GET_ADMIN_KNOWN_CITIES_PATH,
  GetAdminGamesForPostResponse,
  GetAdminKnownCitiesResponse
} from '@core-http';

export class GeneratePostService extends ApiService {
  getGamesForPost(endDays: number, city: string, radius: number): Observable<GetAdminGamesForPostResponse> {
    return this.httpClient.get<GetAdminGamesForPostResponse>(
      `${this.env.apiUrl}${GET_ADMIN_GAMES_FOR_POST_PATH}?gameStartDaysOffset=1&gameEndDaysOffset=${endDays}&city=${city}&radiusInKm=${radius}`
    );
  }

  getKnownCities(): Observable<GetAdminKnownCitiesResponse> {
    return this.httpClient.get<GetAdminKnownCitiesResponse>(`${this.env.apiUrl}${GET_ADMIN_KNOWN_CITIES_PATH}`);
  }
}
